export enum RuleAction {
  SigninSelf = "signin-self",
  SignoutSelf = "signout-self",
  ReadSelf = "read-self",
  Read = "read",
  Write = "write",
  Update = "update",
  Delete = "delete",
}
